<template>
  <div class="spec-wrapper">
    <OverlayLoad :show="overlayShow"></OverlayLoad>
    <van-popup v-model="popupShow" position="bottom" @click-overlay="handleClose" safe-area-inset-bottom closeable
      :style="{ height: '90%' }">
      <div class="spec-content">
        <spec-header :selectedSpec="selectedSpec"></spec-header>
        <div class="spec-content-middle">
          <spec-lump>
            <spec-list-choose :list="specList" @loadAfter="handleSpecChange" />
          </spec-lump>
          <spec-lump>
            <div class="field-wrapper">
              <div class="field-label">
                购买数量<span v-if="selectedSpec.limitNum" class="title-tip">限购{{ selectedSpec.limitNum }}件</span>
              </div>
              <div class="field-content">
                <van-stepper :disable-minus="payCount <= 1"
                  :disable-plus="selectedSpec.limitNum ? payCount >= selectedSpec.limitNum : false"
                  :disabled="!selectedSpec.id" disable-input @overlimit="handleOverlimit"
                  v-model="payCount" />
              </div>
            </div>
          </spec-lump>
          <spec-lump class="warning-section">
            <div class="warning-tip">
              <div class="warning-icon">⚠️</div>
              <div class="warning-text">
                <strong>重要提醒：</strong>请仔细核对充值账户，若充值错误，将无法退回
              </div>
            </div>
          </spec-lump>
          <spec-lump class="recharge-section">
            <div class="recharge-field-wrapper">
              <div class="recharge-field-label">
                <span class="required-star">*</span>
                <span class="label-text">充值账户</span>
              </div>
              <div class="recharge-field-content">
                <van-field 
                  ref="rechargeInput"
                  v-model="rechargeAccount"
                  placeholder="请输入充值账户"
                  :rules="[{ required: true, message: '请输入充值账户' }]"
                  class="recharge-input"
                  maxlength="50"
                  clearable
                  :border="false"
                />
              </div>
            </div>
          </spec-lump>
        </div>

        <div class="pay-button-wrapper">
          <van-goods-action>
            <van-goods-action-button v-if="buyNowShow" type="danger" :disabled="cantBuy" :text="textBuy"
              @click="handlebuyNowClick" />
          </van-goods-action>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SpecListChoose from "./SpecListChoose.vue";
import SpecLump from "./SpecLump.vue";
import SpecHeader from "./SpecHeader.vue";
import OverlayLoad from "./OverlayLoad.vue";
import {
  getSpecInfo,
  isLogin,
  isNoEmptyArr,
} from "./index.action";
import { Toast } from "vant";
export default {
  components: {
    OverlayLoad,
    SpecHeader,
    SpecListChoose,
    SpecLump
  },
  props: {
    goodsType: {
      type: String
    },
    productType: {
      type: String
    },
    list: {
      type: Array
    },
    channelType: {
      type: Number, // 1 全品 2 蛋糕 3 电影
      default: 1
    },
    queryForm: {
      // 查询商品信息所需参数
      type: Object,
      default: function () {
        return {
          cardId: "",
          cityCode: "",
          brandId: "",
          productId: ""
        };
      }
    }
  },
  data() {
    return {
      rechargeAccount: '',//充值账号
      notesText: '', // 备注信息
      buyNowShow: true, // 立即购买按钮显示
      specDataLoad: false, // 规格数据加载锁
      overlayShow: false,
      popupShow: false, // 是否打开展示板
      sendSelectType: 4, //配送类型 默认 无需物流
      shopInfo: {}, // 店铺信息
      isDistribution: null,
      selectedSpec: {}, // 当前选择的规格信息
      specList: [], // 规格信息数组
      cantBuy: false,// 不能买和加入购物车
      textBuy: '立即购买',
      payCount: 1, // 购买数量
      target: null,
      validate_delivery_dates: [],//商家配送数据，计算运费使用
      showAddressBar: 0,// 是否显示结算页面的上方地址栏. 快递商品可以显示,蛋糕类不支持快递的不显示
    };
  },
  watch: {
    list: {
      handler: function (newVal) {
        if (isNoEmptyArr(newVal)) {
          this.specList = newVal;
        }
      },
      immediate: true
    },
    popupShow: {
      handler: function (newVal) {
        if (newVal) {
          // 弹窗打开时，延迟聚焦到充值账户输入框
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.$refs.rechargeInput) {
                this.$refs.rechargeInput.focus();
              }
            }, 300); // 等待弹窗动画完成
          });
        }
      }
    }
  },
  methods: {
    /**
     * 规格选择框打开方法
     */
    async open(typeStr) {
      // 每次打开弹窗时重置充值账户
      this.rechargeAccount = '';
      this.buyNowShow = true;
      this.overlayShow = true;
      if (isNoEmptyArr(this.list)) {
        setTimeout(() => {
          this.overlayShow = false;
          this.popupShow = true;
        }, 500);
      } else {
        const dataList = await getSpecInfo();
        this.overlayShow = false;
        this.specList = dataList;
        this.popupShow = true;
      }
    },

    handleOverlimit(val) {
      if (this.payCount <= 1) {
        if (val == 'plus') {
          Toast("购买数量最多1件");
        } else
          Toast("购买数量最少1件");
        return
      } else if (this.payCount >= this.selectedSpec.limitNum) {
        Toast(`最大购买数量为${this.payCount}件`);
        return
      }
    },
    /**
     * 立即购买
     */
    handlebuyNowClick() {
      if (this.rechargeAccount.trim() ===''){
        //充值账户必填
        Toast('请填写充值账户')
        // 聚焦到输入框
        this.$nextTick(() => {
          if (this.$refs.rechargeInput) {
            this.$refs.rechargeInput.focus();
          }
        });
        return
      }
      if (this.rechargeAccount.length>50){
        Toast('充值账户内容过多,请确认')
        // 聚焦到输入框
        this.$nextTick(() => {
          if (this.$refs.rechargeInput) {
            this.$refs.rechargeInput.focus();
          }
        });
        return
      }
      if (Number(this.selectedSpec.status) === 3) {
        Toast('该商品补货中！请选择其他商品')
        return
      }
      if (Number(this.selectedSpec.status) === 2) {
        Toast('该商品已下架！请选择其他商品')
        return
      }
      this.onSubmit("buyNow");
    },
    onSubmit(type) {
      if (!isLogin()) return;
      this.$emit("submit", {
        type: type,
        selectedSpec: {
          ...this.selectedSpec,
          count: this.payCount // 购买数量
        }, // 当前选择的规格
        deliveryData: {
          sendSelectType: this.sendSelectType, // 配送类型
          showAddressBar: this.showAddressBar, // 是否显示结算页面的上方地址栏. 快递商品可以显示,蛋糕类不支持快递的不显示
        },
        rechargeAccount: this.rechargeAccount
      });
      this.popupShow = false;
    },
    /**
     * 选择规格
     */
    handleSpecChange(record) {
      this.selectedSpec = record || {};
      if (!this.specDataLoad) {
        // loadAfter方法执行时判断
        this.specDataLoad = true;
      } else {
        this.onceLoad();
      }
      this.payCount = 1;
      this.$emit("specChange", { selectedSpec: this.selectedSpec, count: this.payCount });
      if (Number(this.selectedSpec.status) === 3) {
        this.cantBuy = true;
        this.textBuy = '补货中';
      }
    },

    handleClose() {
      this.popupShow = false;
    },
    onceLoad() {
      this.overlayShow = true;
      setTimeout(() => {
        this.overlayShow = false;
      }, 400);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./SpecPopupRecharge";

// 充值账户输入框样式优化
.recharge-field-wrapper {
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  margin: 8px 0;
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;

  .recharge-field-label {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #333;

    .required-star {
      color: #ff4444;
      font-size: 16px;
      font-weight: bold;
      margin-right: 4px;
    }

    .label-text {
      color: #2c3e50;
    }
  }

  .recharge-field-content {
    position: relative;

    .recharge-input {
      background: #f8f9fa;
      border: 1px solid #dee2e6;
      border-radius: 6px;
      font-size: 16px;
      transition: all 0.2s ease;

      // 深度选择器修改vant组件内部样式
      :deep(.van-field__control) {
        font-size: 16px;
        color: #495057;
        font-weight: 400;
        padding: 14px 12px;
        line-height: 1.4;
        background: transparent;

        &::placeholder {
          color: #adb5bd;
          font-size: 14px;
        }
      }

      :deep(.van-field__clear) {
        color: #adb5bd;
        font-size: 14px;
        background: #f1f3f4;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        transition: all 0.2s ease;
        
        &:hover {
          color: #6c757d;
          background: #e9ecef;
        }
        
        &:active {
          background: #dee2e6;
          transform: scale(0.95);
        }
      }

      // 聚焦状态 - 只改变边框颜色，不要双重边框
      &:focus-within {
        border-color: #007bff;
        background: #ffffff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
      }

      // 错误状态
      &.van-field--error {
        border-color: #dc3545;
        background: #fff5f5;
      }
    }
  }
}

// 警告提示样式
.warning-tip {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  margin: 8px 0;

  .warning-icon {
    font-size: 18px;
    margin-right: 8px;
    margin-top: 1px;
  }

  .warning-text {
    flex: 1;
    font-size: 13px;
    line-height: 1.4;
    color: #856404;

    strong {
      color: #664d03;
      font-weight: 600;
    }
  }
}

// 去掉重要提醒和充值账户之间以及充值账户下方的分割线
.spec-content-middle {
  // 重要提醒框 - 去掉下边框
  .spec-lump-wrapper:has(.warning-tip) {
    border-bottom: none !important;
    padding-bottom: 8px;
  }
  
  // 充值账户框 - 去掉下边框  
  .spec-lump-wrapper:has(.recharge-field-wrapper) {
    border-bottom: none !important;
    padding-bottom: 16px;
  }
  
  // 如果浏览器不支持:has选择器，使用类名方式
  .warning-section {
    border-bottom: none !important;
    padding-bottom: 8px;
  }
  
  .recharge-section {
    border-bottom: none !important;
    padding-bottom: 16px;
  }
}

// 响应式设计
@media (max-width: 375px) {
  .recharge-field-wrapper {
    padding: 12px;
    margin: 6px 0;

    .recharge-field-label {
      font-size: 14px;
      margin-bottom: 8px;
    }

    .recharge-field-content .recharge-input :deep(.van-field__control) {
      font-size: 15px;
      padding: 12px 10px;
    }
  }
}
</style>
